export const UNKNOWN_LOCATION = "Unknown Location";

export interface ParsedLocation {
  city: string;
  country: string;
}

export const parseLocationAddress = (address?: string | null): ParsedLocation => {
  const parts = String(address ?? "")
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);

  if (parts.length === 0) {
    return { city: UNKNOWN_LOCATION, country: UNKNOWN_LOCATION };
  }

  const country = parts[parts.length - 1] ?? UNKNOWN_LOCATION;
  return {
    city: parts.length > 1 ? parts[0] ?? country : country,
    country,
  };
};

export const getLocationCountry = (address?: string | null): string =>
  parseLocationAddress(address).country;
